<!-- src/Pages/Home.vue -->
<template>
    <section class="max-w-11xl mx-auto ">
        <BannerCarousel class="pb-6" :banners="banners" />

        <!-- Carrocel de Videos -->
        <!-- <div class="pb-6">
            <CarrocelVideos :videos="videos" />
        </div> -->
        <div v-if="carrosselItems.length"
            class="hidden lg:block relative bg-admin-primary text-white rounded-lg shadow-md overflow-hidden cursor-pointer"
            @click.prevent.stop="nextNoticia(carrosselItems[currentIndex].nickname, carrosselItems[currentIndex].code)">
            <div class="relative h-64 md:h-80 w-full" style="height: 500px;">
                <div v-for="(item, index) in carrosselItems" :key="index"
                    class="absolute inset-0 transition-opacity duration-500 ease-in-out" :class="{
                        'opacity-100': currentIndex === index,
                        'opacity-0': currentIndex !== index
                    }">
                    <img :src="item.image?.trim() || '/images/placeholder.svg'" :alt="item.title"
                        class="w-full h-full object-cover" loading="lazy" decoding="async"
                        @error="(e) => (e.target.src = '/images/placeholder.svg')" />
                </div>
            </div>
            <div
                class="absolute inset-0 p-4 flex flex-col justify-end bg-gradient-to-t from-admin-primary/90 to-transparent">
                <h3 class="font-bold  line-clamp-2 text-white">
                    <p class="text-sm mb-1">
                        {{ carrosselItems[currentIndex]?.formattedDate || 'Data indisponível' }}
                    </p>
                    {{ carrosselItems[currentIndex]?.title || 'Sem título' }}
                </h3>
            </div>
            <div class="absolute top-2 right-2 flex space-x-1">
                <button v-for="(_, index) in carrosselItems" :key="index" @click="currentIndex = index"
                    class="w-2 h-2 rounded-full transition-colors" :class="{
                        'bg-white': currentIndex === index,
                        'bg-white/50': currentIndex !== index
                    }"></button>
            </div>
            <button @click.prevent.stop="prevSlide"
                class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 p-2 rounded-full transition">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <button @click.prevent.stop="nextSlide"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 p-2 rounded-full transition">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
        <div v-if="carrosselItems.length"
            class="lg:hidden relative bg-admin-primary text-white rounded-lg shadow-md overflow-hidden cursor-pointer"
            @click.prevent.stop="nextNoticia(carrosselItems[currentIndex].nickname, carrosselItems[currentIndex].code)">
            <div class="relative h-64 md:h-80 w-full" style="height: 300px;">
                <div v-for="(item, index) in carrosselItems" :key="index"
                    class="absolute inset-0 transition-opacity duration-500 ease-in-out" :class="{
                        'opacity-100': currentIndex === index,
                        'opacity-0': currentIndex !== index
                    }">
                    <img :src="item.image?.trim() || '/images/placeholder.svg'" :alt="item.title"
                        class="w-full h-full object-cover" loading="lazy" decoding="async"
                        @error="(e) => (e.target.src = '/images/placeholder.svg')" />
                </div>
            </div>
            <div
                class="absolute inset-0 p-4 flex flex-col justify-end bg-gradient-to-t from-admin-primary/80 to-transparent">
                <h3 class="font-bold  line-clamp-2 text-white">
                    <p class="text-sm mb-1">
                        {{ carrosselItems[currentIndex]?.formattedDate || 'Data indisponível' }}
                    </p>
                    {{ carrosselItems[currentIndex]?.title || 'Sem título' }}
                </h3>
            </div>
            <div class="absolute top-2 right-2 flex space-x-1">
                <button v-for="(_, index) in carrosselItems" :key="index" @click="currentIndex = index"
                    class="w-2 h-2 rounded-full transition-colors" :class="{
                        'bg-white': currentIndex === index,
                        'bg-white/50': currentIndex !== index
                    }"></button>
            </div>
            <button @click.prevent.stop="prevSlide"
                class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 p-2 rounded-full transition">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <button @click.prevent.stop="nextSlide"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 p-2 rounded-full transition">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
        <div class="lg:hidden">
            <AcessoRapido class="pt-6" />
        </div>
        <!-- COM AGENDA: grid 2 colunas + lista abaixo -->
        <template v-if="atividades_hoje.length > 0">
            <div class="pt-6 grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
                <!-- Card Agenda de Hoje -->
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm p-4 flex flex-col">
                    <AgendaHoje :atividades="atividades_hoje" />
                </div>

                <!-- Card Últimas Notícias (compacto) -->
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm p-4 flex flex-col">
                    <h2 style="font-size: x-large;"
                        class="text-xl font-bold text-admin-primary border-l-4 border-admin-primary pl-4 mb-4">
                        ÚLTIMAS NOTÍCIAS
                    </h2>

                    <div class="flex-1 divide-y divide-gray-100">
                        <div v-for="(news, i) in listaNoticias.slice(0, 4)" :key="i"
                            class="flex gap-3 py-3 first:pt-0 cursor-pointer hover:bg-gray-50 rounded-lg px-2 -mx-2 transition-colors"
                            @click.prevent.stop="nextNoticia(news.nickname, news.code)">

                            <div class="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-gray-100">
                                <img :src="news.image?.trim() || '/images/placeholder.svg'" :alt="news.title"
                                    class="w-full h-full object-cover" loading="lazy" decoding="async"
                                    @error="(e) => (e.target.src = '/images/placeholder.svg')" />
                            </div>

                            <div class="flex-1 min-w-0">
                                <h3 class="text-sm font-semibold text-admin-primary leading-snug"
                                    style="display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;">
                                    {{ news.title }}
                                </h3>
                                <p class="text-xs text-gray-500 mt-1">{{ news.formattedDate }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 pt-3 border-t border-gray-100 text-right">
                        <a href="/noticias-geral"
                            class="text-sm font-medium hover:underline inline-flex items-center gap-1"
                            style="color: #2b529c;">
                            Ver todas as notícias
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Lista restante abaixo dos cards -->
            <div v-if="listaNoticias.length > 4" class="pt-6 space-y-4">
                <div v-for="(news, index) in listaNoticias.slice(4)" :key="index"
                    class="group flex flex-col md:flex-row gap-4 p-4 border border-gray-200 rounded-xl bg-white hover:shadow-lg transition-all duration-200 cursor-pointer overflow-hidden"
                    :class="{ 'md:flex-row-reverse': news.position === 'right' }"
                    @click.prevent.stop="nextNoticia(news.nickname, news.code)">

                    <div class="flex-shrink-0 w-full md:w-1/3">
                        <div class="relative aspect-video rounded-lg overflow-hidden bg-gray-100">
                            <img :src="news.image?.trim() || '/images/placeholder.svg'" :alt="news.title"
                                class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                                loading="lazy" decoding="async"
                                @error="(e) => (e.target.src = '/images/placeholder.svg')" />
                        </div>
                    </div>

                    <div class="flex-1 min-w-0">
                        <h3
                            class="font-bold text-admin-primary text-lg line-clamp-2 leading-tight group-hover:underline transition-colors">
                            {{ news.title }}
                        </h3>
                        <p v-if="news.excerpt" class="text-gray-600 mt-2 line-clamp-2 leading-relaxed break-words">
                            {{ news.excerpt }}
                        </p>
                        <div class="mt-3 flex flex-wrap items-center gap-2 text-xs text-gray-500">
                            <div class="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 flex-shrink-0" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                <span>{{ news.formattedDate }}</span>
                            </div>
                            <div v-if="news.secretarias?.length" class="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 flex-shrink-0" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 21V5a2 2 0 00-2-2h-2a2 2 0 00-2 2v16M5 7l12 6M5 13l12 6" />
                                </svg>
                                <span class="truncate max-w-[120px]">
                                    {{news.secretarias.map(s => s.sigla || s.nome).join(', ')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- SEM AGENDA: lista completa em coluna única -->
        <div v-else class="pt-6 space-y-4">
            <div v-for="(news, index) in listaNoticias" :key="index"
                class="group flex flex-col md:flex-row gap-4 p-4 border border-gray-200 rounded-xl bg-white hover:shadow-lg transition-all duration-200 cursor-pointer overflow-hidden"
                :class="{ 'md:flex-row-reverse': news.position === 'right' }"
                @click.prevent.stop="nextNoticia(news.nickname, news.code)">

                <div class="flex-shrink-0 w-full md:w-1/3">
                    <div class="relative aspect-video rounded-lg overflow-hidden bg-gray-100">
                        <img :src="news.image?.trim() || '/images/placeholder.svg'" :alt="news.title"
                            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            loading="lazy" decoding="async"
                            @error="(e) => (e.target.src = '/images/placeholder.svg')" />
                    </div>
                </div>

                <div class="flex-1 min-w-0">
                    <h3
                        class="font-bold text-admin-primary text-lg line-clamp-2 leading-tight group-hover:underline transition-colors">
                        {{ news.title }}
                    </h3>
                    <p v-if="news.excerpt" class="text-gray-600 mt-2 line-clamp-2 leading-relaxed break-words">
                        {{ news.excerpt }}
                    </p>
                    <div class="mt-3 flex flex-wrap items-center gap-2 text-xs text-gray-500">
                        <div class="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 flex-shrink-0" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <span>{{ news.formattedDate }}</span>
                        </div>
                        <div v-if="news.secretarias?.length" class="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 flex-shrink-0" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 21V5a2 2 0 00-2-2h-2a2 2 0 00-2 2v16M5 7l12 6M5 13l12 6" />
                            </svg>
                            <span class="truncate max-w-[120px]">
                                {{news.secretarias.map(s => s.sigla || s.nome).join(', ')}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mt-8">
            <button class="btn font-semibold" style="color: white; background-color: #1e3a8a;"
                @click="$inertia.visit('/noticias-geral')">
                Mais Notícias
            </button>
        </div>
    </section>
</template>
<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { router, usePage } from '@inertiajs/vue3'
import BannerCarousel from '@/Components/Welcom/BannerCarousel.vue'
// import CarrocelVideos from '@/Components/Shared/CarrocelVideos.vue'
import AcessoRapido from '@/Components/AcessoRapido.vue';
import AgendaHoje from '@/Components/Welcom/AgendaHoje.vue';
const page = usePage()

const banners = computed(() => page.props.banners_ativos || [])
const props = defineProps({
    noticias: {
        type: Array,
        required: true,
        default: () => []
    },
    atividades_hoje: {
        type: Array,
        default: () => []
    },
    videos: {
        type: Array,
        default: () => []
    },
})
const formatBrazilianDate = (dateStr) => {
    if (!dateStr) return '—'
    const [day, month, year] = dateStr.split('/').map(Number)
    const dateObj = new Date(year, month - 1, day)
    if (isNaN(dateObj.getTime())) return dateStr
    const formatter = new Intl.DateTimeFormat('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    })
    let formatted = formatter.format(dateObj)
        .replace(/^\w/, c => c.toUpperCase())
        .replace(/-feira$/, '')
    return formatted
}
const noticiasFiltradas = computed(() => {
    return props.noticias.map((item, index) => ({
        ...item,
        formattedDate: formatBrazilianDate(item.date || item.data_br),
        position: item.position || (index % 2 === 0 ? 'left' : 'right'),
        image: item.image || item.preview_image || '/images/placeholder.svg',
        title: item.title || item.titulo || 'Sem título',
        excerpt: item.excerpt || item.texto_limitado || 'Sem conteúdo.',
        link: item.link || `/noticias/${item.id}/preview`
    }))
})
const carrosselItems = computed(() => {
    return noticiasFiltradas.value.slice(0, 3)
})

const listaNoticias = computed(() => {
    return noticiasFiltradas.value.slice(3)
})
const currentIndex = ref(0)
let intervalId = null
const currentNews = computed(() => carrosselItems.value[currentIndex.value] || {})
const nextSlide = () => {
    if (carrosselItems.value.length <= 1) return
    currentIndex.value = (currentIndex.value + 1) % carrosselItems.value.length
}
const prevSlide = () => {
    if (carrosselItems.value.length <= 1) return
    currentIndex.value = (currentIndex.value - 1 + carrosselItems.value.length) % carrosselItems.value.length
}
onMounted(() => {
    if (carrosselItems.value.length > 1) {
        intervalId = setInterval(nextSlide, 5000)
    }
})
onUnmounted(() => {
    if (intervalId) clearInterval(intervalId)
})

const nextNoticia = (slug, code) => {

    if (!slug || !code) {
        showToast('slug ou code ausente:', 'error');
        return;
    }

    const url = route('noticias.slug.preview', { slug, code });
    router.visit(url);
}
</script>
<style scoped>
img {
    @apply object-cover;
}
</style>
